// Centraliza la lógica de "qué badge mostrar" y "si la carrera se lista o no".
// Si mañana cambia el texto o el color de un badge, se toca UNA sola vez acá,
// no carrera por carrera en el JSON.

export const ESTADOS = {
    NUEVA: 'nueva',
    ABIERTA: 'abierta',
    EXTINCION: 'extincion',
    NO_VIGENTE: 'no_vigente',
};

/**
 * Devuelve el estado + info del badge para una carrera, en base a sus dos
 * banderas (seDicta, abreInscripcion) y la fecha de apertura si la tiene.
 */
export function obtenerEstadoCarrera(carrera) {
    const { seDicta, abreInscripcion, fechaAperturaInscripcion } = carrera;

    if (!seDicta && abreInscripcion) {
        return {
            estado: ESTADOS.NUEVA,
            texto: fechaAperturaInscripcion
                ? `¡NUEVA! Inscripción desde ${formatearFecha(fechaAperturaInscripcion)}`
                : '¡NUEVA! Próxima apertura de inscripción',
            bg: '#ff7a00',
            color: '#ffffff',
        };
    }

    if (seDicta && abreInscripcion) {
        return {
            estado: ESTADOS.ABIERTA,
            texto: 'Inscripción Abierta',
            bg: '#198754',
            color: '#ffffff',
        };
    }

    if (seDicta && !abreInscripcion) {
        return {
            estado: ESTADOS.EXTINCION,
            texto: 'En curso última cohorte – No abre inscripción en 2027',
            bg: '#ffc107',
            color: '#212529',
        };
    }

    return {
        estado: ESTADOS.NO_VIGENTE,
        texto: 'No vigente',
        bg: '#6c757d',
        color: '#ffffff',
    };
}

/** Una carrera se lista en la página si se dicta y/o si tiene inscripción abierta. */
export function esVisible(carrera) {
    return Boolean(carrera.seDicta || carrera.abreInscripcion);
}

/** Formatea "2026-11-01" -> "01/11/2026" para mostrar en la tarjeta. */
export function formatearFecha(fechaISO) {
    if (!fechaISO) return '';
    const [anio, mes, dia] = fechaISO.split('-');
    return `${dia}/${mes}/${anio}`;
}

/** Orden ascendente por el campo "orden"; si falta, va al final. */
export function ordenarCarreras(carreras) {
    return [...carreras].sort((a, b) => (a.orden ?? 9999) - (b.orden ?? 9999));
}